import { createContext } from "react"
import { useForm } from "utility/hooks/useForm"

interface FormContextI<t> extends ReturnType<typeof useForm<t>> {}

const FormContext = createContext({} as FormContextI<any>)

export default FormContext
